import * as yup from 'yup';

function ranking(formatMessage) {
  return yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' ||
      originalValue === null ||
      originalValue === undefined
        ? null
        : value,
    )
    .nullable()
    .optional()
    .typeError(
      formatMessage({
        id: 'RANKING_MUST_BE_A_VALID_NUMBER',
        defaultMessage: 'Ranking must be a valid number',
      }),
    )
    .min(
      1,
      formatMessage({
        id: 'RANKING_MUST_BE_AT_LEAST_1',
        defaultMessage: 'Ranking must be at least 1',
      }),
    )
    .max(
      5,
      formatMessage({
        id: 'RANKING_MUST_BE_AT_MOST_5',
        defaultMessage: 'Ranking must be at most 5',
      }),
    );
}

const validationSchema = formatMessage =>
  yup
    .object({
      ranking: ranking(formatMessage),
    })
    .required();

export default validationSchema;
